import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const deskingPaymentsSuccess = createAction(
  types.DESKINGPAYMENTS_SUCCESS,
);
export const deskingPaymentsFailure = createAction(
  types.DESKINGPAYMENTS_FAILURE,
);

export const deskingOfferPaymentRequest = createAction(
  types.DESKINGOFFERPAYMENT_REQUEST,
);
export const deskingOfferPaymentSuccess = createAction(
  types.DESKINGOFFERPAYMENT_SUCCESS,
);
export const deskingOfferPaymentFailure = createAction(
  types.DESKINGOFFERPAYMENT_FAILURE,
);

export const deskingOfferPaymentDeleteSuccess = createAction(
  types.DESKINGOFFERPAYMENT_DELETE_SUCCESS,
);
export const deskingOfferPaymentDeleteFailure = createAction(
  types.DESKINGOFFERPAYMENT_DELETE_FAILURE,
);

export const deskingBulkPaymentSuccess = createAction(
  types.DESKINGBULKPAYMENT_SUCCESS,
);
export const deskingBulkPaymentFailure = createAction(
  types.DESKINGBULKPAYMENT_FAILURE,
);

export const deskingOfferPaymentCalcStart = createAction(
  types.DESKINGOFFERPAYMENT_CALC_START,
);
export const deskingOfferPaymentCalcEnd = createAction(
  types.DESKINGOFFERPAYMENT_CALC_END,
);

export const setLatestRequestDate = createAction(types.SET_LATEST_REQUEST_DATE);
